module.exports = __webpack_public_path__ + "img/course_bg3.a8570e60.png";